if (!customElements.get('roomix-properties')) {
  customElements.define('roomix-properties', class roomixProperties extends HTMLElement {
    constructor() {
      super();
      this.inputs = this.querySelectorAll('input');
      this.inputs.forEach((input) => {
        if (input.type === 'radio') {
          input.addEventListener('change', this.onChangeRadio);
        }
        if (input.type === 'text') {
          input.addEventListener('keyup', this.onNameType.bind(this));
        }
      });
      this.form = document.querySelector('product-form form');
    }

    connectedCallback() {
      this.createHiddenFormInputProperty(this.inputs[0].attributes.name.value, this.inputs[0].value);
    }

    createHiddenFormInputProperty(attributeName, value) {
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = attributeName;
      hiddenInput.value = value;
      this.form.appendChild(hiddenInput);
    }


    onChangeRadio(event) {
      document.querySelector('input[name="'+ event.target.attributes.name.value +'"][type="hidden"]').value =  event.target.value;
      if (typeof document.querySelector('roomix-summary').updateSteps === "function") {
        document.querySelector('roomix-summary').updateSteps();
      }
    }

    onNameType(event) {
      this.countCharacters(event);
      document.querySelector('input[name="'+ event.target.attributes.name.value +'"][type="hidden"]').value =  event.target.value;
      if (typeof document.querySelector('roomix-summary').updateSteps === "function") {
        document.querySelector('roomix-summary').updateSteps();
      }
    }

    countCharacters(event) {
      let maxNumOfChars = event.target.getAttribute('maxlength');
      let counterElement = event.target.closest('.product-form__input').querySelector('.character-counter span');
      counterElement.innerText = event.target.value.length  +'/'+ maxNumOfChars;
    }

  });
}